export enum TemplateFilterVipStatusEnum {
  All = 'all',
  VipOnly = 'vip_only',
  FreeOnly = 'free_only',
}
